export default {"src":"/_next/static/media/State-of-the-Art Technology cardiology.310a6686.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};